import { Fragment, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import Avatar from "@material-ui/core/Avatar";
import { useHistory } from "react-router-dom";
import { useAuth } from "oidc-react";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

import usePassword from "../../hooks/usePassword";

const ResetPassword = ({ tokenCode, email, returnUrl, ...props }: any) => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const { allValid, mustContainData } = usePassword(
        password,
        confirmPassword
    );

    const history = useHistory();
    var auth = useAuth();
    var classes = useStyles();
    
    useEffect(() => {
        auth?.userManager?.clearStaleState();
    }, [auth]);

    const change = async (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        const response = await fetch(`/api/authenticate/resetpassword/?ReturnUrl=${returnUrl}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                email,
                password,
                confirmPassword,
                code: tokenCode,
            }),
        });

        const data = await response.json();

        if (data) {
            history.replace(`/login/reset/password?ReturnUrl=${returnUrl}`);
        }
    };

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <VpnKeyOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Cambia tu Contraseña
            </Typography>
            <form className={classes.form} noValidate>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    type="password"
                    label="Contraseña"
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="confirmPassword"
                    type="password"
                    label="Reingrese Contraseña"
                    name="confirmPassword"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={(e: any) => change(e)}
                    disabled={!allValid}
                >
                    Cambiar
                </Button>
                <div style={{ marginTop: 20 }}>
                    {mustContainData.map((data, index) => {
                        return (
                            <div key={index}>
                                <ol
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        margin: 0,
                                    }}
                                >
                                    <div>{data[0]}</div>
                                    <div>
                                        {data[1] ? (
                                            <CheckCircleOutlineIcon color="primary" />
                                        ) : (
                                            <CancelOutlinedIcon color="error" />
                                        )}
                                    </div>
                                </ol>
                            </div>
                        );
                    })}
                </div>
            </form>
        </Fragment>
    );
};

export default ResetPassword;
